<template>
    <div id="contractTabs">
        <div class="c-subheader">
            <h5 id="headerContract"></h5>
        </div>
        <ejs-tab id="element" ref=contractTabs :selected="onTabSelected">
            <e-tabitems>
                <e-tabitem :header='headerText0' :content='contractTemplate(propsData)'></e-tabitem>
                <e-tabitem :header='headerText1' :disabled="isAdd" :content='volumeTemplate'></e-tabitem>
                <e-tabitem :header='headerText7' :disabled="isAdd" :content='volumeLogsTemplate'></e-tabitem>
                <e-tabitem :header='headerText2' :disabled="isAdd" :content='triggersTemplate(propsData)'></e-tabitem>
                <e-tabitem :header='headerText3' :disabled="isAdd" :content='defaultDeadlineTemplate'></e-tabitem>
                <e-tabitem :header='headerText4' :disabled="isAdd" :content='formulaTemplate'></e-tabitem>
                <e-tabitem :header='headerText5' :disabled="isAdd" :content='referencePriceTemplate'></e-tabitem>
                <e-tabitem :header='headerText6' :disabled="isAdd" :content='m2mReferenceDatesTemplate'></e-tabitem>
                <e-tabitem :header='headerText8' :disabled="isAdd" :content='defaultMechanismTemplate'></e-tabitem>
            </e-tabitems>
        </ejs-tab>
        <ejs-toast ref='toastrRef' id='contractToast' :position='position'></ejs-toast>
    </div>
</template>
<script>
    import Vue from 'vue';
    import { TabPlugin } from '@syncfusion/ej2-vue-navigations';
    import ContractForm from '@/views/templates/ContractForm.vue';
    import ContractTriggerForm from '@/views/triggers/ContractTrigger.vue';
    import VolumeForm from '@/views/templates/VolumeForm.vue';
    import DefaultDeadlineForm from '@/views/templates/DefaultDeadlineForm.vue';
    import FormulaForm from '@/views/templates/ContractFormulaForm.vue';
    import ReferencePriceForm from '@/views/templates/ReferencePriceForm.vue';
    import M2MReferenceDates from '@/views/templates/M2MReferenceDatesForm.vue';
    import VolumeLogs from '@/views/templates/VolumeLogs.vue';
    import DefaultMechanismForm from '@/views/templates/DefaultDeadlineMechanismForm.vue';
    import { DatePickerComponent, CalendarComponent, DatePickerPlugin, CalendarPlugin } from '@syncfusion/ej2-vue-calendars';

    Vue.use(TabPlugin);
    Vue.component(DatePickerPlugin.name, DatePickerComponent);
    Vue.component(CalendarPlugin.name, CalendarComponent);

    export default {
        name: 'ContractMain',
        created() {
            this.$store.commit('setCurrentContractId', this.$route.params.contractId);
        },         
        data: function () {
            return {
                headerText0: { text: 'Contract' },
                headerText1: { text: 'Volume' },
                headerText2: { text: 'Trigger' },
                headerText3: { text: 'Product Expiry Alert' },
                headerText4: { text: 'Off-Peak Price Calculator' },
                headerText5: { text: 'Reference Price' },
                headerText6: { text: 'Performance watch window' },
                headerText7: { text: 'Volume Logs' },
                headerText8: { text: 'Default Deadline' },
                isAdd: this.$route.params.contractId ? false : true,
                position: { X: 'Right', Y: 'Bottom' },
                propsData: null,
                contractTemplate: function () {
                    return () => {
                        return {
                            template: {
                                extends: ContractForm,
                                propsData: {
                                    tabInstance: this.$refs.contractTabs.ej2Instances,
                                    notificationService: this.$refs.toastrRef
                                }
                            }
                        };
                    };
                },
                volumeTemplate: function () {
                    return {
                        template: {
                            extends: VolumeForm
                        }
                    }
                },
                volumeLogsTemplate: function () {
                    return {
                        template: {
                            extends: VolumeLogs
                        }
                    }
                },
                triggersTemplate: function () {
                    return () => {
                        return {
                            template: {
                                extends: ContractTriggerForm
                            }
                        };
                    };
                },
                defaultDeadlineTemplate: function () {
                    return {
                        template: {
                            extends: DefaultDeadlineForm
                        }
                    }
                },
                formulaTemplate: function () {
                    return {
                        template: {
                            extends: FormulaForm
                        }
                    }
                },
                referencePriceTemplate: function () {
                    return {
                        template: {
                            extends: ReferencePriceForm
                        }
                    }
                },
                m2mReferenceDatesTemplate: function () {
                    return {
                        template: {
                            extends: M2MReferenceDates
                        }
                    }
                },
                defaultMechanismTemplate: function () {
                    return {
                        template: {
                            extends: DefaultMechanismForm
                        }
                    }
                },
            }
        },
        methods: {
            onTabSelected(args) {
                if (args.selectedIndex == 2) {
                   this.$refs.contractTabs.ej2Instances.vueInstance.refresh();
                }
            }
        },
        mounted: function () {
            if (!this.$store.state.permissions["Permissions.Contract.View"]) {
                this.$refs.contractTabs.hideTab(0);
            }
            if (!this.$store.state.permissions["Permissions.Volume.View"]) {
                this.$refs.contractTabs.hideTab(1);
            }
            //if (!this.$store.state.permissions["Permissions.VolumeLogs.View"]) {
            //    this.$refs.contractTabs.hideTab(1);
            //}
            if (!this.$store.state.permissions["Permissions.Triggers.View"]) {
                this.$refs.contractTabs.hideTab(2);
            }
            if (!this.$store.state.permissions["Permissions.DefaultDeadline.View"]) {
                this.$refs.contractTabs.hideTab(3);
            }
            if (!this.$store.state.permissions["Permissions.OffPeakPrice.View"]) {
                this.$refs.contractTabs.hideTab(4);
            }
            if (!this.$store.state.permissions["Permissions.ReferencePrice.View"]) {
                this.$refs.contractTabs.hideTab(5);
            }
            if (!this.$store.state.permissions["Permissions.M2MReferenceDate.View"]) {
                this.$refs.contractTabs.hideTab(6);
            }
            if (!this.$store.state.permissions["Permissions.DefaultDeadline.View"]) {
                this.$refs.contractTabs.hideTab(8);
            }
        }
    }
</script>

<style scoped>
</style>

<style>
    #headerContract {
        color: #8a93a2;
        margin-top: 10px;
        margin-left: 11px;
    }
</style>